module.exports = __webpack_public_path__ + "img/neos.bd1b141b.svg";